import { render, staticRenderFns } from "./StatusDelivery.vue?vue&type=template&id=424329e2&scoped=true&lang=pug"
import script from "./StatusDelivery.vue?vue&type=script&lang=js"
export * from "./StatusDelivery.vue?vue&type=script&lang=js"
import style0 from "./StatusDelivery.vue?vue&type=style&index=0&id=424329e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424329e2",
  null
  
)

export default component.exports